import { InjectionToken } from '@angular/core';

export const APP_ENVIRONMENT = new InjectionToken('Application environmental variables');
